import { useGetList } from "ra-core";

import type { Tag } from "../types";

// Tags are a small, closed vocabulary that every consumer wants in full: the
// picker on a contact, the filter sidebar, and the filter summary all render
// the whole list. Fetching a page of them is never what any caller wants.
//
// This existed as the same four lines copy-pasted into three components, each
// asking for `perPage: 10`. Production carries 34 tags, so everything from
// roughly "m" onwards was invisible — a contact tag named "Main Prospects" was
// created four times because it never appeared after the first attempt.
//
// 500 is headroom, not a limit anyone should hit. The real ceiling is PostgREST
// `max_rows = 1000` (supabase/config.toml), which truncates silently rather than
// erroring, so asking for more than that would quietly describe behaviour the
// server does not provide.
export const TAG_FETCH_LIMIT = 500;

// Returns the whole useGetList result so callers take what they need: `data`
// everywhere, plus `isPending` where the component gates its render on it.
export const useAllTags = () =>
  useGetList<Tag>("tags", {
    pagination: { page: 1, perPage: TAG_FETCH_LIMIT },
    sort: { field: "name", order: "ASC" },
  });
